<template>
	<div class="tabbar">
		<ul>
			<li v-for="(item, index) in tabList" :key="index" @click="onTab(item)">{{item.tabName}}</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'tabbar',
	data () {
		return {
			tabList: [
				{
					tabName: '新闻',
					ico: '',
					path: '/'
				},
				{
					tabName: '融媒',
					ico: '',
					path: 'mediaConvergence'
				},
				{
					tabName: '矩阵',
					ico: '',
					path: 'matrix'
				},
				{
					tabName: '便民',
					ico: '',
					path: 'convenientPeople'
				},
				{
					tabName: '直播',
					ico: '',
					path: 'live'
				}
			]
		}
	},
	methods: {
		onTab(val) {
			if(val.path !== this.$route.name) {
				this.$router.push({path: val.path})
			}
		}
	}
}
</script>

<style lang="less" scoped>
	.tabbar {
		width: 100%;
		height: 50px;
		border-top: 1px solid #ddd;
		position: fixed;
		bottom: 0;
		left: 0;
		background-color: #FFFFFF;
		ul {
			display: flex;
			height: 100%;
			li {
				flex: 1;
				text-align: center;
				line-height: 50px;
			}
		}
	}
</style>
